<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>I arrived in Britain in 1967 to join my mother and stepfather at the age of 14. After leaving school at 16, I spent three years in the British Army. After leaving the army, I worked as a truck driver for many years, until 1992 when I returned to academic studies. In 1997 I achieved a 2:1 (Hons.) degree from Luton University, followed by a post-graduate Diploma and a Masters’ degree from De Montfort University in 2004. My first book, <em>Stolen Inheritance</em>, was published in 2019, after many years of research. <em>Man, God, Religion, and State</em> is my second publication and I hope readers will find it stimulating and enjoyable.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?405b7a33